import { Injector } from "@angular/core";
import { ResultList } from "../../ListEntity/ResultList";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { environment } from "../../../../../../environments/environment";
import { BaseNode } from "../../BaseNode";
import { EntityEnum } from "../../EntityEnum";
import { PaginationControl } from "../../../PaginationControl";
import { WebTraderQueryResultNode } from "../WebTraderQueryResultNode";
import { DateUtil } from "../../../DateUtil";
import { testingEnum } from "../../../../common/enum/testingEnum";
import { Art57NodeUtils } from "../../Art57Node/Art57NodeUtils";
import { QueryNodeToEudravigilance } from "../Query/QueryNodeToEudravigilance";
import { QueryConditionNodeToEudravigilance } from "../Query/QueryConditionNodeToEudravigilance";
import { ToEudravigilanceListView } from "../../../Data/WebTraderData/ToEudravigilanceListView";

export class ResultListNodeToEudravigilance extends ResultList {

    constructor (injector: Injector) {
        super(injector);
    }

    override addResult(requestedNode: BaseNode, itemPagination: PaginationControl,data: any, parentNode: BaseNode): BaseNode|null{
        const listViewData = new ToEudravigilanceListView(data);
        let resultNodeToEudravigilance = null;
        const selectedNode = requestedNode; 
        if ( selectedNode instanceof QueryNodeToEudravigilance || selectedNode instanceof WebTraderQueryResultNode) {
            selectedNode.data = listViewData;
        } else {
            const conditionsNode = Art57NodeUtils.findChildNodeOfType(this.parent!.children as BaseNode[],QueryConditionNodeToEudravigilance) as QueryConditionNodeToEudravigilance;
            resultNodeToEudravigilance = new WebTraderQueryResultNode(this.ioc!,listViewData,"Result " + DateUtil.getResultDateTime(), EntityEnum.toEV,null,conditionsNode, []);
            resultNodeToEudravigilance.paginationControl = itemPagination;
            if (data.length == 0) {
              this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', id:testingEnum.noResultsFoundToastMsg, detail: 'No result(s) found for the specified condition(s)', life: environment.warningElapsedTime });
            }  
        
            if (!(this.ioc!.get(Art57Section).getSelectedSection().selectedNode instanceof QueryNodeToEudravigilance)) {
                resultNodeToEudravigilance.parent = parentNode;
                this.children?.push(resultNodeToEudravigilance);
            } else {
                resultNodeToEudravigilance.parent = requestedNode;
            }    
        }

        return resultNodeToEudravigilance;
    }
}